import { render, staticRenderFns } from "./refund-dialog.vue?vue&type=template&id=18bd449d&scoped=true&"
import script from "./refund-dialog.vue?vue&type=script&lang=js&"
export * from "./refund-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bd449d",
  null
  
)

export default component.exports